import React, { useEffect, useState } from 'react'
import { Button, Modal, Form } from 'react-bootstrap'
import { useForm } from 'react-hook-form';
import SmashSpinner from '../../../components/SmashSpinner/SmashSpinner';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux/hooks';
import { planUsageState, unsubscribeSubscription } from '../planUsageSlice';

const PlanCancelModal = () => {
    const dispatch = useAppDispatch();
    const [show, setShow] = useState(false);
    const {planUsage, isLoading, isSuccess } = useAppSelector(planUsageState);

    type FormValues = {
        reasonType: "NOT_NEEDED_ANYMORE" | "TOO_SLOW" | "OTHER" | undefined;
        description: string;
    };

    const { handleSubmit, formState: { errors, isValid }, register, reset, unregister, } = useForm<FormValues>({
        mode: "onChange",
        reValidateMode: "onChange",
    });

    const handleClose = () => {
        // reset();
        setShow(false);
    };

    const handleShow = () => {
        reset();
        setShow(true)
    };

    const submitHandler = (values: FormValues) => {
        dispatch(unsubscribeSubscription(values));
    };

    const [toggleReasonDescription, setReasonDescription] = useState(false);

    const toggleDescription = (event:any)=> {
        const toggle = event.target.value === 'OTHER';
        setReasonDescription(toggle);
        if(!toggle) 
            unregister('description');        
    }

    useEffect(() => {
        if (isSuccess) {
            handleClose();
        }
    }, [isSuccess]);

  return (
    <>
        {planUsage?.automaticRenew && !isLoading && planUsage.status === 'Active' && <Button onClick={handleShow} variant='outline-primary'>Cancel plan</Button>}
        <Modal centered show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <h4>Cancel plan</h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            {isLoading && <SmashSpinner/> }
            {!isLoading && <>
                <p>To help us to improve Smash, please could you let us know why you’d like to cancel your subscription?</p>
                <Form noValidate onSubmit={handleSubmit(submitHandler)} id="unsubscribe-reason-form">
                    <Form.Check
                        id="NOT_NEEDED_ANYMORE"                       
                        {...register('reasonType', { required: true })} 
                        type="radio"
                        label="I currently no longer need to send files."
                        value="NOT_NEEDED_ANYMORE"
                        isInvalid={!!errors.reasonType}
                        onChange={toggleDescription} 
                        />   

                    <Form.Check 
                        id="TOO_SLOW"
                        {...register('reasonType', { required: true })}
                        type="radio"
                        value="TOO_SLOW"
                        label="The file sending is not fast enough."
                        isInvalid={!!errors.reasonType}
                        onChange={toggleDescription} 
                        />
                
                    <Form.Check                        
                        id="OTHER"
                        {...register('reasonType')}
                        type="radio"
                        value="OTHER"    
                        label="Other"                            
                        isInvalid={!!errors.reasonType}
                        onChange={toggleDescription} 
                        />   
                    {errors.reasonType?.type === "required" && (
                            <Form.Control.Feedback type="invalid">
                                You must select a reason
                            </Form.Control.Feedback>)}

                    {toggleReasonDescription && <Form.Group className="mb-3" controlId="description">
                        <Form.Control
                            {...register('description', { required: true} )}
                            type="text"
                            placeholder="Type in your reason"
                            isInvalid={!!errors.description}
                        />
                        {errors.description?.type === "required" && (
                            <Form.Control.Feedback type="invalid">
                                You must enter a description
                            </Form.Control.Feedback>)}
                            </Form.Group>}
                </Form>
            </>}
            </Modal.Body>
            {!isLoading && <Modal.Footer>                 
                <Button onClick={handleClose} variant='light'>Close</Button>
                <Button disabled={!isValid} type='submit' form='unsubscribe-reason-form'>Confirm</Button>
            </Modal.Footer>}
        </Modal>
    </>
  )
}

export default PlanCancelModal